export default __webpack_public_path__ + "static/media/a' leughadh.0a83a8c0.mp3";